//src/pages/admin/Benutzerverwaltung.jsx
import { useEffect, useState, useContext } from "react";
import {
    Box,
    Heading,
    Input,
    Button,
    Flex,
    Text,
    VStack,
    Badge,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import AuthContext from "../../context/AuthContext";

import { Pencil } from "lucide-react";



export default function Benutzerverwaltung() {
    const [users, setUsers] = useState([]);
    const [filter, setFilter] = useState("");
    const navigate = useNavigate();
    const { user: currentUser } = useContext(AuthContext);


    useEffect(() => {
        console.log("API URL:", process.env.REACT_APP_API_URL); // 👈 HERE
        console.log("token:", currentUser?.token);
        if (!currentUser || !currentUser.token) return;
        axios
            .get(`${process.env.REACT_APP_API_URL}/api/users`, {
                headers: {
                    Authorization: `Bearer ${currentUser.token}`,
                },
            })
            .then((res) => {
                console.log(res.data);
                const filtered = res.data.filter(u => u.adminLevel !== "GLOBAL");
                setUsers(filtered);
            })
            .catch((err) => console.error("Error loading users:", err));
    }, [currentUser]);
    const filteredUsers = users.filter((u) =>
        `${u.firstName ?? ""} ${u.lastName ?? ""} ${u.email}`
            .toLowerCase()
            .includes(filter.toLowerCase())
    );

    const roleLabel = (u) => {
        if (u.role === "ROLE_ADMIN") return "admin";
        return "user";
    };

    return (
        <Box maxW="6xl" mx="auto" mt={10} p={8} bg="white" borderRadius="xl" boxShadow="lg">
            {/* HEADER */}
            <Flex justify="space-between" align="center" mb={6}>
                <Heading size="lg" letterSpacing="wide" color="blue.400">
                    BENUTZER
                </Heading>

                <Button
                    colorScheme="blue"
                    onClick={() => navigate("/admin/benutzerverwaltung/add")}
                >
                    + Add User
                </Button>
            </Flex>

            {/* SEARCH */}
            <Input
                placeholder="Suche"
                value={filter}
                onChange={(e) => setFilter(e.target.value)}
                maxW="300px"
                mb={6}
            />

            {/* USER LIST */}
            <VStack spacing={0} align="stretch" borderWidth="1px" borderRadius="md">
                {filteredUsers.map((u) => (
                    <Flex
                        key={u.id}
                        justify="space-between"
                        align="center"
                        px={4}
                        py={3}
                        borderBottomWidth="1px"
                        _last={{ borderBottomWidth: 0 }}
                    >
                        <Box>
                            <Text fontWeight="semibold" textTransform="uppercase">
                                {u.firstName || u.email}
                            </Text>
                            <Text fontSize="sm" color="gray.500">
                                {u.email}
                            </Text>
                        </Box>

                        <Flex align="center" gap={3}>
                            <Badge
                                colorScheme={u.role === "ROLE_ADMIN" ? "orange" : "blue"}
                                textTransform="lowercase"
                            >
                                {roleLabel(u)}
                            </Badge>

                            <Button
                                size="sm"
                                 display="flex"
                                 alignItems="center"
                                onClick={() => navigate(`/admin/benutzerverwaltung/edit/${u.id}`)}
                            >
                                <Pencil size={16} style={{ marginRight: 6 }} />
                                Edit
                            </Button>
                        </Flex>
                    </Flex>
                ))}
            </VStack>
        </Box>
    );
}